module.exports = __webpack_public_path__ + "static/media/iso9002.f9eac88f.jpeg";